(function () {
    'use strict';

    function CustomerPickerComponentController($state, $timeout, $scope, $stateParams, OrderBag, OrderBagCustom, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSession, CustomerCustom, Customer, Principal, $uibModal, $rootScope, translate, translatePartialLoader) {
        //
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.noCache = false;
        $ctrl.querySearch = querySearch;
        $ctrl.customer_changed = customer_changed;

        $ctrl.newCustomerPopUp = newCustomerPopUp;
        $ctrl.newCustomer = newCustomer;
        $ctrl.searchCustomerByPhoneNumber = searchCustomerByPhoneNumber;

        $ctrl.selectedCustomer = null;
        $ctrl.isCustomerManager = false;

        $ctrl.selectedCustomerChanged = function (selectedItem) {
            if (selectedItem) {
                $ctrl.selectedItem = selectedItem;
                var c = Customer.get({id: selectedItem.id});
                if (c != null) {
                    $ctrl.customer = c;
                    $ctrl.existCustomerSearchResult = [];
                }
            }
        }
        $ctrl.searchCustomer = function (query) {
            return CustomerCustom.searchCustomerBySearch(query).query();
        }

        Principal.hasAuthority("ROLE_CUSTOMER_MANAGER").then(function (has) {
            $ctrl.isCustomerManager = has;
        });


        loadAll();
        loadPage();

        function loadAll() {

            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {

            translatePartialLoader.addPart('customer');
            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();


        }


        function querySearch(query) {

            var temp = [];

            angular.forEach($ctrl.customers, function (item) {
                if (item.itemTitle.indexOf(query) > -1) {
                    temp.push(item);
                } else if (query == null) {
                    temp = $ctrl.customers;
                }
            })

            return temp;

        }

        function customer_changed(item) {

        }

        function searchCustomerByPhoneNumber() {

            if (!$ctrl.customer.personalInfo.phoneNumber || $ctrl.customer.personalInfo.phoneNumber.length < 6 || $ctrl.customer.personalInfo.phoneNumber.length == 11) {
                $ctrl.existCustomerSearchResult = [];
                return;
            }

            CustomerCustom.searchCustomerBySearch($ctrl.customer.personalInfo.phoneNumber).query().$promise.then(function (result) {
                $ctrl.existCustomerSearchResult = result;
            });

        }

        function newCustomer() {
            $ctrl.phoneNumberToFind = "";
            $ctrl.customer = {};
            $ctrl.customerMode = "new";
            $ctrl.myRole = "ROLE_USER";
        }

        function newCustomerPopUp() {

            if ($ctrl.onNewCustomerPopUpClick) {
                $ctrl.onNewCustomerPopUpClick();
                return;
            }

            $rootScope.modalInstance = $uibModal.open({
                templateUrl: 'app/entities/company-customer/company-customer-modal.html',
                controller: 'CompanyCustomerModalController',
                controllerAs: '$ctrl',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'pl-modal',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('personInfo');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            // title: null,
                            // level: null,

                            id: null
                        };
                    }
                }
            });

            $rootScope.modalInstance.result.then(function (v) {

                $ctrl.customer = v.customer;
                //reload();
            }, function () {
                //nothing
            });
        }

    }

    var CustomerPickerComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/customer-picker/partial-form.customer-picker.html',
        controller: CustomerPickerComponentController,
        bindings:
            {
                customer: '=',
                onNewCustomerPopUpClick: "&",
                onCustomerChanged: "&",
                readOnly: '=?',
                showStatistic: '=?'

            }

    };

    angular
        .module('tikonApp')
        .component('pfCustomerPicker', CustomerPickerComponent)

    CustomerPickerComponentController.$inject = ['$state', '$timeout', '$scope', '$stateParams', 'OrderBag', 'OrderBagCustom', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSession', 'CustomerCustom', 'Customer', 'Principal', '$uibModal', '$rootScope', '$translate', '$translatePartialLoader'];


})();

